import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { isShiftPlanEnabled } from "../../../../feature-module/utils/commonUtils";

const ViewRegistration = ({ viewObj }) => {
  const [viewObjData, setViewObjData] = useState([]);

  useEffect(() => {
    if (viewObj) {
      setViewObjData(viewObj);
    }
  }, [viewObj]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = String(date.getFullYear()); // Get last two digits of the year
    return `${day}-${month}-${year}`;
  };

  return (
    <div>
      <style>
        {`
        @media (max-width: 576px) {
          #offcanvasRightViewReg {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightViewReg {
            width: 55% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightViewReg {
            width: 40% !important;
          }
        }
          
       @media (min-width: 1441px) and (max-width:2550px) {
          #offcanvasRightViewReg {
            width: 28% !important;
          }
        }
        @media (min-width:2551px) {
          #offcanvasRightViewReg {
            width:20% !important;
          }
        }
        `}
      </style>
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightViewReg"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">View Registration</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>{" "}
        <hr />
        <div className="offcanvas-body">
          <form>
            <div className="content">
              <div className="row">
                <div className="col-6 mb-2">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={viewObjData?.UserName || "N/A"}
                    readOnly
                  />
                </div>
                <div className="col-6 mb-2">
                  <label className="form-label">Emp ID</label>
                  <input
                    type="text"
                    className="form-control"
                    value={viewObjData?.Badge || "N/A"}
                    readOnly
                  />
                </div>
                <div className="col-6 mb-2">
                  <label className="form-label">Biometric</label>
                  <input
                    type="text"
                    className="form-control"
                    value={viewObjData?.CardId || "N/A"}
                    readOnly
                  />
                </div>
                <div className="col-6 mb-2">
                  <label className="form-label">RFID</label>
                  <input
                    type="text"
                    className="form-control"
                    value={viewObjData?.RFID || "N/A"}
                    readOnly
                  />
                </div>
                <div className="col-6 mb-2">
                  <label className="form-label">DOB</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formatDate(viewObjData?.DateOfBirth) || "N/A"}
                    readOnly
                  />
                </div>
                <div className="col-6 mb-2">
                  <label className="form-label">DOJ</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formatDate(viewObjData?.DateOfJoining) || "N/A"}
                    readOnly
                  />
                </div>
                <div className="col-6 mb-2">
                  <label className="form-label">Mobile</label>
                  <input
                    type="text"
                    className="form-control"
                    value={viewObjData?.Mobile || "N/A"}
                    readOnly
                  />
                </div>
                <div className="col-6 mb-2">
                  <label className="form-label">Email ID</label>
                  <input
                    type="text"
                    className="form-control"
                    value={viewObjData?.EmailId || "N/A"}
                    readOnly
                  />
                </div>
                <div className="col-6 mb-2">
                  <label className="form-label">Gender</label>
                  <select
                    className="form-select"
                    name="Gender"
                    value={viewObjData?.Gender?.toString() || ""}
                    readOnly
                  >
                    <option value="" disabled>
                      Select Gender
                    </option>
                    <option value="1">Male</option>
                    <option value="0">Female</option>
                  </select>
                </div>
                <div className="col-6 mb-2">
                  <label className="form-label">Designation</label>
                  <input
                    type="text"
                    className="form-control"
                    value={viewObjData?.Designation || "N/A"}
                    readOnly
                  />
                </div>
                <div className="col-6 mb-2">
                  <label className="form-label">Department</label>
                  <input
                    type="text"
                    className="form-control"
                    value={viewObjData?.DepartmentName || "N/A"}
                    readOnly
                  />
                </div>
                {isShiftPlanEnabled() && (
                  <div className="col-6 mb-2">
                    <label className="form-label">Shift</label>
                    <input
                      type="text"
                      className="form-control"
                      value={viewObjData?.ShiftName || "N/A"}
                      readOnly
                    />
                  </div>
                )}
                <div className="col-6 mb-2 d-none">
                  <label className="form-label">Branch</label>
                  <input
                    type="text"
                    className="form-control"
                    value={viewObjData?.BranchName || "N/A"}
                    readOnly
                  />
                </div>
              </div>
              <div>
                <button
                  type="button"
                  className="btn btn-secondary d-flex ms-auto mt-3"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

ViewRegistration.propTypes = {
  viewObj: PropTypes.object.isRequired,
};

export default ViewRegistration;
